module.exports = __webpack_public_path__ + "img/d625639.jpg";